import { SortType } from '@/enums/sort-type.enum';
import { SortState } from '@/interfaces/states/sort-state.interface';

const state: SortState = {
  type: SortType.CMS_ASC,
};

export default state;
